import {StrainSaveMeasurementGageMountingModel} from "@app/strain/common/models/save-measurement-models/strain-save-measurement-gage-mounting.model";
import {StrainExecutionMode} from "@app/strain/common/models/enum/strain-execution-mode.enum";
import {StrainTestType} from "@app/strain/common/models/enum/strain-test-type.enum";

export class StrainSaveMeasurementDetailsModel {
    public frequencyId: number;
    public measuringEquipmentId: number;
    public processResponsible: string;
    public measurementType: StrainTestType;
    public temperature: number;
    public humidity: number;
    public measurementMethod: StrainExecutionMode;
    public strainResultGageMounting: StrainSaveMeasurementGageMountingModel;

    constructor(entry: any = {}) {
        this.frequencyId = entry.frequencyId;
        this.measuringEquipmentId = entry.measuringEquipmentId;
        this.processResponsible = entry.processResponsible;
        this.measurementType = entry.measurementType;
        this.temperature = entry.temperature;
        this.humidity = entry.humidity;
        this.measurementMethod = entry.measurementMethod;
    }
}
